import { apiClient } from "@/services/api";
import type { ApiKey, ApiKeyCreateRequest, ApiKeyCreatedResponse, ApiKeyRotateResponse } from "@/types/apiKey";

const BASE = "/api/v1/api-keys";

export const apiKeysService = {
  list: () => apiClient.get<ApiKey[]>(BASE),
  create: (data: ApiKeyCreateRequest) => apiClient.post<ApiKeyCreatedResponse>(BASE, data),
  revoke: (uuid: string) => apiClient.delete(`${BASE}/${uuid}`),
  rotate: (uuid: string) => apiClient.post<ApiKeyRotateResponse>(`${BASE}/${uuid}/rotate`),
};
